export default __webpack_public_path__ + "static/media/fNeutral13.e96b55c0.png";